<template>
  <div class="table-body">
    <Row
      v-for="row in tableData"
      :key="row.id"
      :config="config"
      :row-data="row"
      :clickable-rows="clickableRows"
      @row-click="(val) => $emit('row-click', val)"
      @btn-click="(val) => $emit('btn-click', val)"
      @delete-row="(val) => $emit('delete-row', val)"
    />
  </div>
</template>

<script>
/**
 * Тело таблицы
 * @module Shared/Component/Table/TableBody
 * @requires Shared/Table/Row
 * @vue-prop {Array} config - конфиг таблицы
 * @vue-prop {Array} tableData - данные для отображения
 * @vue-prop {Boolean} clickableRows - переключает кликабельность строк
 * */

import Row from 'Shared/Table/Row'

export default {
  name: 'TableBody',
  components: {
    Row
  },
  props: {
    config: {
      type: Array,
      default: () => []
    },
    tableData: {
      type: Array,
      default: () => []
    },
    clickableRows: {
      type: Boolean,
      default: false
    }
  }
}
</script>
